import {useTranslation} from '@aboutyou/i18n';
import React, {FC} from 'react';
import styled from 'styled-components';
import {GenericIconName} from '../../atoms/Icon/IconName';
import {SliderControlProps} from '../../molecules/HorizontalSlider/types';
import {
  NavButton,
  StyledCircleButton,
} from './ProductTileImageSliderSideButtons';

export const ThumbnailsSideButtons: FC<SliderControlProps> = ({
  prev,
  next,
  nextIsActive,
  prevIsActive,
  loop = false,
  maxPages,
}) => {
  const {t} = useTranslation();
  if (maxPages === 1) {
    return null;
  }
  return (
    <>
      <StyledNavButton
        onClick={prev}
        isActive={prevIsActive}
        iconName={GenericIconName.ArrowLeft}
        iconSize="XS"
        data-testid="arrowLeft"
        aria-label={t('Go to the previous slide')}
      />
      <StyledNavButton
        onClick={next}
        isActive={nextIsActive || loop}
        iconName={GenericIconName.ArrowRight}
        iconSize="XS"
        isNextButton
        data-testid="arrowRight"
        aria-label={t('Go to the next slide')}
      />
    </>
  );
};

const StyledNavButton = styled(NavButton)`
  && {
    --distance-from-border: 4px;
    background: rgba(255, 255, 255, 0.2);
    backdrop-filter: blur(6px);
  }

  ${StyledCircleButton} {
    width: 24px;
    height: 24px;
  }
`;
